// global fetch, URL
// import {
//   DIRECTEUR, VSKO_VERANTWOORDELIJKE, OU_TYPE_CONFIG, CHILD_MANAGERS
// } from 'ReduxLoop/api/apiResourceFactory';
import { getNonAbolishedResources } from '@kathondvla/sri-client/date-utils';
// const LogRocket = require('logrocket');
import LogRocket from 'logrocket';
import {
  sriClient,
  oauthClient,
  securityClient,
  goToOauthLogin,
  goToLogOut,
} from 'ReduxLoop/utils/apiConfig';
import { settings } from 'Js/config/settings';
import { LOGIN_METHODS } from 'ReduxLoop/constants';
import { getUserTargetGroup } from './piwikUtils';
import { getKathOndvlaParents } from '../profile/profileCommands';
import { EDUCATION_LEVEL_MAP } from '../constants';

const SriClientError = require('@kathondvla/sri-client/sri-client-error');

export async function getUser() {
  const me = await oauthClient.get('/me', undefined, { credentials: 'include' });
  return sriClient.get(`/persons/${me.uuid}`);
}

export function goToOauthLoginScreen() {
  goToOauthLogin();
}

export function identifyUserInLogRocket(userInfo) {
  if (settings.logRocket.enabled) {
    LogRocket.identify(userInfo.key, {
      name: `${userInfo.firstName} ${userInfo.lastName}`,
      email: userInfo.$$email,
    });
  }
}

export function doLogOut() {
  goToLogOut();
}

export const getOrganisationalUnit = async (key) => {
  const ouPermalink = `/sam/organisationalunits/${key}`;
  let ou = null;
  try {
    ou = await sriClient.get(ouPermalink);
  } catch (err) {
    if (err instanceof SriClientError && err.status === 404) {
      const kathOndVlaPermalink = `/kathondvla/organisationalunits/${key}`;
      ou = await sriClient.get(kathOndVlaPermalink);
    } else {
      throw err;
    }
  }
  return ou;
};

export const getPositions = () => {
  return sriClient.getAll('/positions', { expand: 'FULL' });
};

const getOusFromResourcesRaw = (resourcesRaw, regex) => {
  const ret = [];
  const samOrgsToRead = resourcesRaw.filter((raw) => raw.match(regex));
  samOrgsToRead.forEach((raw) => {
    const regExpUuid = new RegExp(
      /([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/g
    );
    let m;
    do {
      m = regExpUuid.exec(raw);
      if (m) {
        ret.push(m[1]);
      }
    } while (m);
  });
  return ret;
};

const getOuTypesFromResourcesRaw = (resourcesRaw, regex) => {
  const ret = new Set();
  const adminUpdateUrls = resourcesRaw.filter((raw) => raw.match(regex));
  // console.log(adminUpdateUrls);
  adminUpdateUrls.forEach((raw) => {
    const match = raw.match(/typeIn=([^&]+)/);
    if (match) {
      const types = match[1].split(',').filter((type) => type !== 'CLASS' && type !== 'TEACHER_GROUP');
      types.forEach((type) => {
        ret.add(type);
      });
    }
  });
  return ret;
};

export const getUserResponsibilities = async (user) => {
  const responsibilities = await sriClient.getAll('/responsibilities', {
    persons: user.$$meta.permalink,
    expand: 'FULL',
    expandRelationsTo: 'SUMMARY',
    expandPosition: 'NONE',
  });

  const nonAbolishedResponsibilities = getNonAbolishedResources(responsibilities);

  const samHrefs = Array.from(
    new Set(
      nonAbolishedResponsibilities
        .filter((resp) => resp.organisationalUnit.href.match(/^\/sam\//g))
        .map((resp) => resp.organisationalUnit.href)
    )
  );
  const samOus = await sriClient.getAllHrefs(samHrefs);

  const kathOndVlaHrefs = Array.from(
    new Set(
      nonAbolishedResponsibilities
        .filter((resp) => resp.organisationalUnit.href.match(/^\/kathondvla\//g))
        .map((resp) => resp.organisationalUnit.href)
    )
  );
  const kathOndVlaOus = await sriClient.getAllHrefs(kathOndVlaHrefs);

  const teacherGroupHrefs = [];
  nonAbolishedResponsibilities
    .filter((resp) => resp.organisationalUnit.href.match(/^\/sam\//g))
    .forEach((resp) => {
      const ou = samOus.find((thisOu) => thisOu.$$meta.permalink === resp.organisationalUnit.href);
      if (ou && ou.type === 'TEACHER_GROUP') {
        teacherGroupHrefs.push(ou.$$meta.permalink);
      }
    });
  const groupParentRelations =
    teacherGroupHrefs.length === 0
      ? []
      : await sriClient.getAll(
          '/sam/organisationalunits/relations',
          { type: 'IS_PART_OF', from: teacherGroupHrefs },
          { inBatch: '/sam/organisationalunits/batch' }
        );
  
  // FETCHIN SECURITY INFORMATION
  let ousWithAccessToInvitations = [];
  let ousWithReadAccessToResps = [];
  let ousWithUpdateAccessToResps = [];
  let ousWithGrantAccessToSensitiveInformation = [];
  const isSuperAdmin = await securityClient.get(
    '/security/query/allowed',
    {
      ability: 'super_admin',
      component: '/security/components/mijn-app',
      person: user.$$meta.permalink,
    },
    { inBatch: '/security/query/batch' }
  );
  const ouAdminRights = await securityClient.get(
    '/security/query/resources/raw',
    {
      ability: 'update',
      component: '/security/components/samenscholing-api',
      person: user.$$meta.permalink,
    },
    // { inBatch: '/security/query/batch' }
  );
  // eslint-disable-next-line no-constant-condition
  // if (true || !isSuperAdmin) {
    // If true is not there you will get kicked out of teams where you are made admin...
    const pendingOuRegex =
      /^\/responsibilities\/pending\?organisations=\/(?:organisations|sam\/organisationalunits)\/(?:[0-9a-f-]+)(?:,\/(?:organisations|sam\/organisationalunits)\/(?:[0-9a-f-]+))*$/g;

    const ouRegex =
      /^\/responsibilities\?organisations=\/(?:organisations|sam\/organisationalunits)\/(?:[0-9a-f-]+)(?:,\/(?:organisations|sam\/organisationalunits)\/(?:[0-9a-f-]+))*,?$/g;
    const resourceRawRead = await securityClient.getRaw('/security/query/resources/raw', {
      ability: 'read',
      component: '/security/components/persons-api',
      person: user.$$meta.permalink,
    });
    ousWithAccessToInvitations = getOusFromResourcesRaw(resourceRawRead, pendingOuRegex);
    ousWithReadAccessToResps = getOusFromResourcesRaw(resourceRawRead, ouRegex);

    /* const samOrgsToRead = resourceRawRead.filter(raw => raw.match(regex));
    samOrgsToRead.forEach(raw => {
      const regExpUuid = new RegExp(/([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/g);
      let m;
      do {
        m = regExpUuid.exec(raw);
        if (m) {
          readableOus.push(m[1]);
        }
      } while (m);
    }); */

    const resourceRawUpdate = await securityClient.getRaw('/security/query/resources/raw', {
      ability: 'update',
      component: '/security/components/persons-api',
      person: user.$$meta.permalink,
    });
    ousWithUpdateAccessToResps = getOusFromResourcesRaw(resourceRawUpdate, ouRegex);

    const resourcesRawCreate = await securityClient.getRaw('/security/query/resources/raw', {
      ability: 'create',
      component: '/security/components/persons-api',
      person: user.$$meta.permalink,
    });
    ousWithGrantAccessToSensitiveInformation = getOusFromResourcesRaw(
      resourcesRawCreate,
      /^\/responsibilities\?positions=\/positions\/0f61688e-05c2-4e3f-8cea-9da46f5d92cc(:?,\/positions\/[0-9a-f-]{36})*&organisations=\/(?:organisations|sam\/organisationalunits)\/(?:[0-9a-f-]+)(?:,\/(?:organisations|sam\/organisationalunits)\/(?:[0-9a-f-]+))*,?$/g
    );
  // }

  const adminForOuTypes = ouAdminRights.some((raw) => raw.match(/^\/kathondvla\/organisationalunits\?\$\$meta\.deleted=any$/))
    ? new Set(['ALL'])
    : getOuTypesFromResourcesRaw(ouAdminRights, /^\/(kathondvla|sam)\/organisationalunits\?typeIn=[^&]+(&wasEverMemberOf=[^&]+)?$/);

  return {
    userResponsibilities: nonAbolishedResponsibilities,
    samOus,
    kathOndVlaOus,
    groupParentRelations,
    ousWithAccessToInvitations,
    ousWithReadAccessToResps,
    ousWithUpdateAccessToResps,
    ousWithGrantAccessToSensitiveInformation,
    isSuperAdmin,
    canDeleteKathOndVlaOus: new Set(['matthias.snellings', 'griet.perdieus', 'magda.sabbe']).has(user.username),
    adminForOuTypes,
  };
};

export const getUserLoginMethod = async (user) => {
  const result = await sriClient.getList('/loginsessions', {
    persons: `/persons/${user.key}`,
    limit: 1,
    applications: 'mijn-2.0',
    descending: true,
    orderBy: 'start',
    omit: '$$meta.count',
  });
  return LOGIN_METHODS[result[0]?.loginProvider?.href] || null;
};

export const calculateUserTargetGroup = async (
  userResponsibilities,
  ous,
  dienstParentRelations
) => {
  const targetGroups = await sriClient.getAll('/namedsets', {
    tags: 'doelgroepen',
  });
  const result = getUserTargetGroup({
    userResponsibilities,
    targetGroups,
    ous,
    dienstParentRelations,
  });
  return result;
};

/* export const getKathOndVlaOus = async (kathOndVlaResps) => {
  const kathOndVlaHrefs = Array.from(new Set(kathOndVlaResps.map((resp) => resp.organisation.href)));
  const ous = kathOndVlaHrefs.length === 0 ? [] : await sriClient.getAllHrefs(kathOndVlaHrefs);

  const kathOndVlaRespInfo = await getKathOndvlaParents(kathOndVlaResps, map);

  const map = Object.fromEntries([...ous, ...kathOndVlaRespInfo.parentOus].map((ou) => [ou.$$meta.permalink, ou]));
  return {
    ous: map,
    parentRelations: kathOndVlaRespInfo.parentRelations,
  };
}; */

/* export const getCampusses = (ous) => {
  const ouHrefs = ous.map(ou => ou.$$meta.permalink);
  if (ouHrefs.length === 0) {
    return [];
  }
  return sriClient.getAll('/sam/organisationalunits/locations', { organisationalUnit: ouHrefs, expand: 'results.physicalLocation', type: 'CAMPUS', endDateAfter: getNow() });
}; */

export const getAllContactDetails = async (ous) => {
  const samHrefs = ous
    .filter((ou) => ou.type !== 'TEACHER_GROUP' && ou.$$meta.permalink.match(/^\/sam\//g))
    .map((ou) => ou.$$meta.permalink);
  if (samHrefs.length === 0) {
    return [];
  }
  const samContactDetails = samHrefs.length ? await sriClient.getAllReferencesTo(
    '/sam/organisationalunits/contactdetails',
    undefined,// { type: 'MAIL' }, for popup we need everything, unless we filter out the school entities, but that's two calls so probably less performant
    'organisationalUnit',
    samHrefs,
  ) : [];
  const kathOndVlaHrefs = ous
    .filter((ou) => ou.$$meta.permalink.match(/^\/kathondvla\//g))
    .map((ou) => ou.$$meta.permalink);
  const kathOndVlaContactDetails = kathOndVlaHrefs.length ? await sriClient.getAllReferencesTo(
    '/kathondvla/organisationalunits/contactdetails',
    { type: 'MAIL' },
    'organisationalUnit',
    kathOndVlaHrefs,
  ) : [];
  return [...samContactDetails.filter((cd) => !cd.physicalLocation), ...kathOndVlaContactDetails];
};

export const getInstitutionNumbersAndEducationLevels = async (ous) => {
  const institutions = ous
    .filter((ou) => ou.$$meta.permalink.match(/^\/sam\//g) && ou.type !== 'SCHOOLENTITY' && ou.type !== 'TEACHER_GROUP');

  const institutionNumbers = await sriClient.getAllReferencesTo(
    '/sam/organisationalunits/externalidentifiers',
    { type: 'INSTITUTION_NUMBER'} ,
    'organisationalUnit',
    institutions.map((ou) => ou.$$meta.permalink)
  );

  const schools = ous.filter((ou) => ou.type === 'SCHOOLENTITY' || ou.type === 'SCHOOL');
  const msEpds = await sriClient.getAllReferencesTo(
    '/sam/educationalprogrammedetails',
    { hasMainstructure: true, expand: 'results.mainstructure' },
    'organisationalUnit',
    schools.map((ou) => ou.$$meta.permalink)
  );
  const educationLevelMap = {};
  msEpds.forEach((epd) => {
    if (!educationLevelMap[epd.organisationalUnit.href]) {
      const [educationLevel] = Object.entries(EDUCATION_LEVEL_MAP).find(([, msCodes]) => msCodes.has(epd.mainstructure.$$expanded.code));
      educationLevelMap[epd.organisationalUnit.href] = educationLevel;
    }
  });

  return {
    institutionNumbers: Object.fromEntries(institutionNumbers.map((inNumber) => ([inNumber.organisationalUnit.href, inNumber.value]))),
    educationLevels: educationLevelMap,
  };
};